export default __webpack_public_path__ + "static/media/status-blue.623565e3.svg";